export default __webpack_public_path__ + "static/media/SM2.195d6545.jpg";